import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

window.addEventListener('message', function (evt) {
  if (evt.origin === 'http://localhost:8000' || evt.origin === 'https://reconfig.no') {
    if (evt.data.type === 'submit') {
      console.log('--submit', evt.data);
      const { firstName, lastName, email, jobTitle, organization } = evt.data;
      window.submitResult(firstName, lastName, jobTitle, organization, email);
    } else if (evt.data.type === 'send-email') {
      setTimeout(window.sendEmail, 200);
    } else if (evt.data.type === 'start-challenge') {
      window.startChallenge();
    }
  }
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
